import React from 'react';
import {Modal} from 'components/modals';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import GoogleCalendarImage from 'img/google-calendar-icon@2x.png';
import AppleCalendarImage from 'img/apple-calendar-icon@2x.png';
import MicrosoftCalendarImage from 'img/microsoft-outlook-icon@2x.png';

const InstructionItem = ({message}) => {
  return (
    <li className='mt2'>
      <span className='block pl1'><FormattedMessage id={message}/></span>
    </li>
  );
};

const CalendarInstructions = () => {
  return (
    <div>
      <div className='flex'>
        <div className='col-2 sm-and-below-hide mr2'>
          <img role='presentation' src={GoogleCalendarImage} width='80px'/>
        </div>
        <div className='col-12 sm-col-10'>
          <div className='h3'><FormattedMessage id='user_settings.calendars.instructions.google.Sync with Google Calendar'/></div>
          <ol className='pl2'>
            <InstructionItem message='user_settings.calendars.instructions.google.GOOGLE_STEP_ONE'/>
            <InstructionItem message='user_settings.calendars.instructions.google.GOOGLE_STEP_TWO'/>
            <InstructionItem message='user_settings.calendars.instructions.google.GOOGLE_STEP_THREE'/>
          </ol>
        </div>
      </div>
      <div className='flex mt3'>
        <div className='col-2 sm-and-below-hide mr2'>
          <img role='presentation' src={AppleCalendarImage} width='80px'/>
        </div>
        <div className='col-12 sm-col-10'>
          <div className='h3'><FormattedMessage id='user_settings.calendars.instructions.apple.Sync with Apple Calendar'/></div>
          <ol className='pl2'>
            <InstructionItem message='user_settings.calendars.instructions.apple.APPLE_STEP_ONE'/>
            <InstructionItem message='user_settings.calendars.instructions.apple.APPLE_STEP_TWO'/>
            <InstructionItem message='user_settings.calendars.instructions.apple.APPLE_STEP_THREE'/>
          </ol>
        </div>
      </div>
      <div className='flex mt3'>
        <div className='col-2 sm-and-below-hide mr2'>
          <img role='presentation' src={MicrosoftCalendarImage} width='80px'/>
        </div>
        <div className='col-12 sm-col-10'>
          <div className='h3'><FormattedMessage id='user_settings.calendars.instructions.outlook.Sync with Microsoft Outlook'/></div>
          <div className='h3 mt2'>
            <FormattedMessage id='user_settings.calendars.instructions.outlook.Web Application'/>
          </div>
          <ol className='pl2'>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_WEB_STEP_ONE'/>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_WEB_STEP_TWO'/>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_WEB_STEP_THREE'/>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_WEB_STEP_FOUR'/>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_WEB_STEP_FIVE'/>
          </ol>
          <div className='h3 mt2'>
            <FormattedMessage id='user_settings.calendars.instructions.outlook.Desktop Application'/>
          </div>
          <ol className='pl2'>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_DESKTOP_STEP_ONE'/>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_DESKTOP_STEP_TWO'/>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_DESKTOP_STEP_THREE'/>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_DESKTOP_STEP_FOUR'/>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_DESKTOP_STEP_FIVE'/>
            <InstructionItem message='user_settings.calendars.instructions.outlook.OUTLOOK_DESKTOP_STEP_SIX'/>
          </ol>
        </div>
      </div>
    </div>
  );
};

const CalendarInstructionsModal = observer(({modalOpen, uiState}) => {
  return (
    <Modal
      isOpen={modalOpen}
      onHide={() => uiState.closeCalendarInstructionsModal()}
      size='md'
      title='user_settings.calendars.instructions.Syncing Calendars'
    >
      <CalendarInstructions/>
    </Modal>
  );
});

export default CalendarInstructionsModal;
